import Vue from'vue';export default{pixelWidth:167*0.95,get ratio(){return{width:462/249*0.95,height:462/249*0.95}},step:10,initial_step:10,heights:{xs:10,xl:315},widths:{s:60,m:90}};


//////////////////
// WEBPACK FOOTER
// ./app/components/data/k2.js
// module id = 211
// module chunks = 0